export function getGWTIsQueryMode() {
    return (
        window['formTable'] &&
        window['formTable'].getIsQueryMode &&
        window['formTable'].getIsQueryMode()
    );
}

export function getIsQueryForm() {
    return (
        window['formTable'] &&
        window['formTable'].getIsQueryForm &&
        window['formTable'].getIsQueryForm()
    );
}

export function isRelatedFieldKeyColumn() {
    return (
        window['formTable'] &&
        window['formTable'].isRelatedFieldKeyColumn &&
        window['formTable'].isRelatedFieldKeyColumn()
    );
}

export function getIsEmptyTable() {
    return (
        window['formTable'] && window['formTable'].getIsEmpty && window['formTable'].getIsEmpty()
    );
}

export function setNewSearch(index: number, name: string) {
    window['formTable'] &&
        window['formTable'].setNewSearch &&
        window['formTable'].setNewSearch(index, name);
}

export function getZoomName() {
    return (
        window['formTable'] && window['formTable'].getZoomName && window['formTable'].getZoomName()
    );
}

export function getCurrentColNumber() {
    return (
        window['formTable'] &&
        window['formTable'].getCurrentColNumber &&
        window['formTable'].getCurrentColNumber()
    );
}

export function getCurrentRowNumber() {
    return (
        window['formTable'] &&
        window['formTable'].getCurrentRowNumber &&
        window['formTable'].getCurrentRowNumber()
    );
}

export function getValueByColName(name) {
    return (
        window['formTable'] &&
        window['formTable'].getValueByColName &&
        window['formTable'].getValueByColName(name)
    );
}

export function getParentValueByColName(colName: string) {
    return (
        window['formTable'] &&
        window['formTable'].getParentValueByColName &&
        window['formTable'].getParentValueByColName(colName)
    );
}

export function getMainFormValueByColName(colName: string) {
    return (
        window['formTable'] &&
        window['formTable'].getMainFormValueByColName &&
        window['formTable'].getMainFormValueByColName(colName)
    );
}

export function isActiveRowEmpty() {
    return (
        window['formTable'] &&
        window['formTable'].isActiveRowEmpty &&
        window['formTable'].isActiveRowEmpty()
    );
}

export function getKeysObject() {
    return (
        window['formTable'] &&
        window['formTable'].getMainTableKeysObject &&
        window['formTable'].getMainTableKeysObject()
    );
}

export function getCurTableKeysObject() {
    return (
        window['formTable'] &&
        window['formTable'].getCurTableKeysObject &&
        window['formTable'].getCurTableKeysObject()
    );
}

export function isColumnMandatory(name: string): boolean {
    return (
        window['formTable'] &&
        window['formTable'].isColumnMandatory &&
        window['formTable'].isColumnMandatory(name)
    );
}

export type ExposedOldAPIFormState = {
    formName: string;
    level: number;
    keys: Array<{columnName: string; value: string}>;
};

export function getActiveFormsState(): ExposedOldAPIFormState[] {
    const formsState = window['formTable']?.getActiveFormsState?.();
    if (formsState) {
        const res = formsState.map(
            (
                data: {
                    name: string;
                    keys: {[columnName: string]: string};
                },
                index: number
            ) => {
                return {
                    formName: data.name,
                    level: index,
                    keys: Object.entries(data.keys)
                        .map(([columnName, value]) => {
                            if (!value) return null;

                            return {
                                columnName,
                                value
                            };
                        })
                        .filter(Boolean)
                } as ExposedOldAPIFormState;
            }
        );

        return res;
    }
    return [];
}

/**
 * This function is a mimic of getActiveFormsState().
 * It's needed for cases when the returning keys are not the complete keys of the form
 * (this could happen when some of the key columns are not visible in the form).
 *
 * @returns Array of active forms state with all of the columns as keys
 */
export function getActiveFormsStateWithoutKeys(): ExposedOldAPIFormState[] {
    const formsState = window['formTable']?.getActiveFormsStateWithoutKeys?.();
    if (formsState) {
        const res = formsState.map(
            (
                data: {
                    name: string;
                    keys: {[columnName: string]: string};
                },
                index: number
            ) => {
                return {
                    formName: data.name,
                    level: index,
                    keys: Object.entries(data.keys)
                        .map(([columnName, value]) => {
                            if (!value) return null;

                            return {
                                columnName,
                                value
                            };
                        })
                        .filter(Boolean)
                } as ExposedOldAPIFormState;
            }
        );

        return res;
    }
    return [];
}
